/*
 * Maja & Helena - meta-conversion.js (v3, 2026-10-06)
 * Wordt ALLEEN geladen door templates/product.meta-conversion.json.
 * Raakt de standaardtemplate en size-guard.js (schoenmaten) niet.
 *
 * 1. Kledingmaat: geen voorgeselecteerde maat (ook niet via ?variant=), ATC + sticky ATC
 *    geblokkeerd tot de klant bewust een maat aantikt. Uitzondering: is er voor de gekozen
 *    kleur maar één beschikbare maat (bijv. Uniwersalny), dan geldt die als gekozen.
 * 2. Kleurwissel: voorkomt dat de pagina naar boven springt.
 * 3. Promo: "OFERTA NA KONIEC LATA" -> herfstboodschap (alleen op deze template).
 * 4. Kaching-drawer: trustregel onder de checkoutknop.
 * 5. Kleurlabel: "Kolor (<gekozen kleur>)" boven de swatches.
 */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  var SIZE = 'Rozmiar';
  var COLOR = 'Kolor';
  var HINT = 'Wybierz rozmiar';
  var ERROR = 'Wybierz rozmiar, aby dodać produkt do koszyka.';
  var UNCONF = 'mc-size-unconfirmed';
  var SHOE = /^\d{2}(?:[.,]5)?$/;
  var ATC_SEL = '.main-product-atc, .main-product-form button[name="add"], .main-product-form .atc-button';

  function sizeRadios() {
    return [].slice.call(document.querySelectorAll('variant-selects input[type="radio"][name="' + SIZE + '"]'));
  }

  function isShoe(radios) {
    return radios.length && radios.every(function (r) { return SHOE.test(String(r.value).trim()); });
  }

  /* ---------- 1. Maatkeuze ---------- */

  var sizeActive = false;
  var autoConfirmed = false; /* enige beschikbare maat automatisch geaccepteerd */

  function sizeGroup() {
    var r = sizeRadios()[0];
    return r ? (r.closest('fieldset') || r.closest('.product-form__input')) : null;
  }

  function copyUncheckedLook() {
    var radios = sizeRadios();
    var plain = null;
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) {
        plain = document.querySelector('label[for="' + radios[i].id + '"]');
        if (plain) break;
      }
    }
    if (!plain) return;
    var cs = getComputedStyle(plain);
    ROOT.style.setProperty('--mc-pill-bg', cs.backgroundColor);
    ROOT.style.setProperty('--mc-pill-color', cs.color);
    ROOT.style.setProperty('--mc-pill-border', cs.borderColor);
  }

  function ensureMsg() {
    var group = sizeGroup();
    if (!group) return null;
    var msg = group.querySelector('.mc-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'mc-size-msg';
      msg.setAttribute('role', 'status');
      msg.textContent = HINT;
      group.appendChild(msg);
    }
    msg.hidden = !ROOT.classList.contains(UNCONF);
    return msg;
  }

  /* Beschikbare maatwaarden voor de huidige keuze van de overige opties (bijv. kleur). */
  function availableSizes() {
    var vs = document.querySelector('variant-selects');
    var json = vs && vs.querySelector('script[type="application/json"]');
    if (!json) return null;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return null; }
    var names = [];
    [].forEach.call(vs.querySelectorAll('input[type="radio"][name], select[name]'), function (el) {
      if (names.indexOf(el.name) === -1) names.push(el.name);
    });
    var sIdx = names.indexOf(SIZE);
    if (sIdx === -1) return null;
    var current = names.map(function (n) {
      var el = vs.querySelector('input[type="radio"][name="' + n + '"]:checked') || vs.querySelector('select[name="' + n + '"]');
      return el ? el.value : null;
    });
    var sizes = [];
    variants.forEach(function (v) {
      if (!v.available || !v.options) return;
      for (var i = 0; i < names.length; i++) {
        if (i !== sIdx && current[i] !== null && v.options[i] !== current[i]) return;
      }
      if (sizes.indexOf(v.options[sIdx]) === -1) sizes.push(v.options[sIdx]);
    });
    return sizes;
  }

  function setUnconfirmed() {
    copyUncheckedLook();
    ROOT.classList.add(UNCONF);
    var msg = ensureMsg();
    if (msg) { msg.textContent = HINT; msg.classList.remove('is-error'); }
  }

  function evaluateSize() {
    var radios = sizeRadios();
    if (!radios.length || isShoe(radios)) return; /* schoenen: size-guard.js */
    var first = !sizeActive;
    sizeActive = true;
    var sizes = availableSizes();
    if (sizes && sizes.length === 1) {
      /* Eén beschikbare maat: automatisch geselecteerd, direct bestelbaar */
      var only = null;
      radios.forEach(function (r) { if (r.value === sizes[0]) only = r; });
      if (only && !only.checked) {
        var lab = document.querySelector('label[for="' + only.id + '"]');
        (lab || only).click();
      }
      autoConfirmed = true;
      confirmSize();
      return;
    }
    /* Meerdere maten: bewuste keuze verplicht */
    if (first || autoConfirmed) {
      autoConfirmed = false;
      setUnconfirmed();
    } else {
      ensureMsg();
    }
  }

  function confirmSize() {
    ROOT.classList.remove(UNCONF);
    var msg = ensureMsg();
    if (msg) { msg.hidden = true; msg.classList.remove('is-error'); }
  }

  function showError() {
    var msg = ensureMsg();
    if (msg) {
      msg.textContent = ERROR;
      msg.classList.add('is-error');
      msg.hidden = false;
    }
    var group = sizeGroup();
    if (group) {
      try { group.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { group.scrollIntoView(); }
      group.classList.remove('mc-shake');
      void group.offsetWidth;
      group.classList.add('mc-shake');
    }
  }

  document.addEventListener('click', function (e) {
    if (!sizeActive || !e.target.closest) return;

    var pick = e.target.closest('variant-selects label[for], variant-selects input[name="' + SIZE + '"]');
    if (pick) {
      var input = pick.tagName === 'INPUT' ? pick : document.getElementById(pick.getAttribute('for'));
      if (input && input.name === SIZE) { autoConfirmed = false; confirmSize(); }
      return;
    }

    if (ROOT.classList.contains(UNCONF) && e.target.closest(ATC_SEL)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (sizeActive && (e.key === 'Enter' || e.key === ' ') && e.target && e.target.name === SIZE) { autoConfirmed = false; confirmSize(); }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!sizeActive || !ROOT.classList.contains(UNCONF)) return;
    var f = e.target;
    if (f && f.closest && f.closest('.main-product-form, product-form')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    }
  }, true);

  /* Kleur/optie gewijzigd: maatstatus opnieuw bepalen (1 maat -> auto, meerdere -> verplicht) */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects') && e.target.name !== SIZE) {
      setTimeout(evaluateSize, 0);
      setTimeout(evaluateSize, 400);
    }
  }, true);

  /* ---------- 2. Kleurwissel zonder sprong naar boven ---------- */

  var keepY = null;
  var userScrolled = false;

  ['touchstart', 'wheel', 'keydown'].forEach(function (t) {
    window.addEventListener(t, function () { if (keepY !== null) userScrolled = true; }, { passive: true });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pick = e.target.closest('variant-selects label[for], variant-selects input[name="' + COLOR + '"]');
    if (!pick) return;
    var input = pick.tagName === 'INPUT' ? pick : document.getElementById(pick.getAttribute('for'));
    if (!input || input.name !== COLOR) return;

    keepY = window.pageYOffset;
    userScrolled = false;
    [250, 600, 1000, 1600].forEach(function (ms) {
      setTimeout(function () {
        if (keepY === null || userScrolled) return;
        if (window.pageYOffset < keepY - 120) window.scrollTo(0, keepY);
      }, ms);
    });
    setTimeout(function () { keepY = null; }, 1700);
  }, true);

  /* ---------- 3. Eén promoboodschap ---------- */

  function fixPromo() {
    [].forEach.call(document.querySelectorAll('.announcement-bar__message'), function (el) {
      if (/KONIEC LATA/i.test(el.textContent) && !el.getAttribute('data-mc')) {
        el.textContent = 'JESIENNA WYPRZEDAŻ · DO -70%';
        el.setAttribute('data-mc', '1');
      }
    });
  }

  /* ---------- 4. Kaching-drawer trustregel ---------- */

  function drawerTrust() {
    var btn = document.querySelector('.kaching-cart__checkout-button');
    if (!btn || !btn.parentNode) return;
    if (btn.parentNode.querySelector('.mc-drawer-trust')) return;
    var p = document.createElement('p');
    p.className = 'mc-drawer-trust';
    p.textContent = 'Darmowa dostawa · BLIK · 30 dni na zwrot';
    btn.parentNode.insertBefore(p, btn.nextSibling);
  }

  /* ---------- 5. Kleurlabel met gekozen kleur ---------- */

  function colorLabel() {
    [].forEach.call(document.querySelectorAll('variant-selects'), function (vs) {
      var checked = vs.querySelector('input[type="radio"][name="' + COLOR + '"]:checked');
      if (!checked) return; /* geen kleuroptie: label ongemoeid laten */
      var group = checked.closest('fieldset') || checked.closest('.product-form__input');
      var label = group && group.querySelector('.form__label, legend');
      if (!label) return;
      var base = label.getAttribute('data-mc-base');
      if (!base) {
        base = label.textContent.replace(/\s+/g, ' ').trim();
        label.setAttribute('data-mc-base', base);
      }
      var text = base + ' (' + checked.value + ')';
      if (label.textContent.replace(/\s+/g, ' ').trim() !== text) label.textContent = text;
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === COLOR && e.target.closest && e.target.closest('variant-selects')) colorLabel();
  }, true);

  /* ---------- Start + herinitialisatie na her-renders ---------- */

  function run() {
    evaluateSize();
    fixPromo();
    drawerTrust();
    colorLabel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 80);
  }).observe(document.body, { childList: true, subtree: true });
})();
